import request from './request'
import { FEEDBACK_SUBMIT_URL } from './config'

/**
 * 提交问题反馈
 * @param {Object} params
 * @param {string} params.type     - 问题类型（function / experience / suggest / other）
 * @param {string} params.desc     - 问题描述
 * @param {string} [params.contact] - 联系方式（可选）
 */
export function submitFeedback (params) {
  return request.post(FEEDBACK_SUBMIT_URL, {
    type: params.type,
    desc: params.desc,
    phone: params.contact || ''
  })
}
